const MiddleNav = ()=> {


    return (
        <section id="middle-nav-container" className="sticky top-0 w-full my-8 bg-transparent border-b-2 border-white z-10">
            <nav id="middle-nav-list-container" className=" w-full ">
            <ul className=" list-none flex flex-row justify-around bg-gradient-to-br from-customyellow to-customdarkblue px-2 py-4 w-full sm-max:grid sm-max:grid-cols-2 overflow-hidden">
                <div className="flex flex-row align-middle justify-center p-2 ">    
                <li  className="flex align-middle justify-center px-2 text-lg "><a href="#about" className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 sm-max:justify-start" >About</a></li>
                </div>
                <div className="flex flex-row items-center  p-2 ">
   
                <li className="flex align-middle justify-center px-2 text-lg "><a href="#experience" className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 "> Experience</a></li>
                </div>
                <div className="flex flex-row items-center  p-2 ">
   
                <li className="flex align-middle justify-center px-2 text-lg "><a href="#builds" className="flex items-center  text-lg text-white hover:text-customyellow focus:text-red-900 "> Builds</a></li>
                </div>
                <div className="flex flex-row items-center justify-center p-2 ">
   
                <li className="flex align-middle justify-center px-2 text-lg "><a href="#contact" className="flex items-center  text-lg text-white hover:text-customyellow focus:text-red-900 "> Contact</a></li>
                </div>
                <div className="flex flex-row items-center p-2">    
                <li className="flex align-middle justify-center px-2 text-lg "><a href="https://yanickndi.herokuapp.com/cv" className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 "> Resume</a></li>
                </div>
                </ul>
            </nav>
        </section>
    );
}


export default MiddleNav;